import { render } from "./nos-services.vue?vue&type=template&id=025030e3&scoped=true"
import script from "./nos-services.vue?vue&type=script&lang=js"
export * from "./nos-services.vue?vue&type=script&lang=js"

import "./nos-services.vue?vue&type=style&index=0&id=025030e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025030e3"]])

export default __exports__